import { ComponentPropsWithoutRef } from "react"

import { classNames } from "../../../../lib/classNames"

interface KeyboardTileProps extends ComponentPropsWithoutRef<"div"> {
  color?: KeyboardTileColor
  keyboardKey?: string
}

export const KeyboardTileColors = {
  Blue: "blue",
  LightBlue: "light-blue",
  White: "white",
  Gray: "gray",
} as const

export type KeyboardTileColor =
  (typeof KeyboardTileColors)[keyof typeof KeyboardTileColors]

export const colorStyles: Record<KeyboardTileColor, string> = {
  [KeyboardTileColors.Blue]:
    "bg-cobalt-500 text-cobalt-100 dark:bg-gray-700 dark:text-gray-300",
  [KeyboardTileColors.LightBlue]:
    "bg-cobalt-100 text-cobalt-400 dark:bg-cobalt-500 dark:text-cobalt-100",
  [KeyboardTileColors.White]:
    "bg-white text-gray-500 dark:bg-gray-700 dark:text-gray-300 shadow-sm",
  [KeyboardTileColors.Gray]:
    "bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-300",
}

export function KeyboardTile({
  color = "white",
  keyboardKey,
  className,
  children,
  ...otherProps
}: KeyboardTileProps) {
  return (
    <div
      className={classNames(
        "flex min-h-5 min-w-5 items-center justify-center rounded-sm",
        colorStyles[color],
        className
      )}
      {...otherProps}
    >
      {children ?? <p className="text-body mx-1">{keyboardKey}</p>}
    </div>
  )
}
